<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "screen",
  data() {
    return {};
  },
  created() {}
};
</script>
